export default {"src":"/_next/static/media/tabler_mood-empty.6619884c.svg","height":58,"width":59,"blurWidth":0,"blurHeight":0};